import { ComponentProps, useContext } from "react"
import { Heading, Link, Box, useBreakpointValue, Flex } from "@chakra-ui/react"
import uttaLogo from "src/assets/media/utta_icon.png"
import learnmachineLogo from "src/assets/media/learnmachineLogo.png"
import livesellLogo from "src/assets/media/livesell_icon.png"
import x121Logo from "src/assets/media/x121_icon.png"
import { useIsMobileApp } from "src/util/deviceType"
import { SDKContext } from "src/context/SDKContext"
import useConfig from "src/hooks/useConfig"

export const ConditionalAppLogo = ({ showLogo = false }) => {
  const { platformName } = useConfig()
  const logoMarginTop = useBreakpointValue({ base: "6px", md: "3px" })
  let conditionalLogo: string | null = uttaLogo
  switch (platformName) {
    case "LearnMachine":
      conditionalLogo = learnmachineLogo
      break
    case "LiveSell":
      conditionalLogo = livesellLogo
      break
    case "loading":
      conditionalLogo = null
      break
    case "Utta":
      conditionalLogo = uttaLogo
      break
    case "x121":
      conditionalLogo = x121Logo
      break
  }

  let conditionalLogoBG: string | undefined = "#FBF703"
  switch (platformName) {
    case "LearnMachine":
      conditionalLogoBG = "#F2A93C"
      break
    case "LiveSell":
      conditionalLogoBG = "#FBF703"
      break
    case "loading":
      conditionalLogoBG = undefined
      break
    case "Utta":
      conditionalLogoBG = "#FBF703"
      break
    case "x121":
      conditionalLogoBG = "#FFC0CB"
      break
  }

  const renderLogoOrText = () => {
    if (showLogo && conditionalLogo) {
      return (
        <img
          src={conditionalLogo}
          style={{
            background: conditionalLogoBG,
            borderRadius: "4px",
            position: "relative",
            width: "34px",
            minWidth: "34px",
            height: "34px"
          }}
        />
      )
    }
    switch (platformName) {
      case "x121":
        return (
          <Box mt="3px">
            <Box
              borderRadius={"5px"}
              p="3px"
              h="40px"
              display="flex"
              alignItems="center"
              mt={logoMarginTop}
              background={conditionalLogoBG}
              ml="10px"
              textAlign={"center"}
            >
              <Heading
                // w="81.414px"
                w="76px"
                h="20px"
                as="h1"
                fontFamily="Raleway"
                fontWeight="900"
                fontSize="30px"
                letterSpacing="2px"
                lineHeight="20px"
                fontStyle="italic"
                color="black"
              >
                {platformName}
              </Heading>
            </Box>
          </Box>
        )
      case "LearnMachine":
        return (
          <Flex mt="-1px" alignItems={"center"}>
            {!!conditionalLogo && (
              <img
                src={conditionalLogo}
                style={{
                  marginTop: "5px",
                  background: conditionalLogoBG,
                  borderRadius: "4px",
                  position: "relative",
                  width: "30px",
                  minWidth: "30px",
                  height: "30px"
                }}
              />
            )}
            <Box
              // borderRadius={"5px"}
              // p="18px 10px"
              mt={logoMarginTop}
              // background={conditionalLogoBG}
              ml="5px"
            >
              <Heading
                as="h1"
                textTransform={"uppercase"}
                fontFamily="roboto"
                fontWeight={400}
                fontSize="25px"
                letterSpacing="2px"
                lineHeight="20px"
                color="white"
              >
                {platformName}
              </Heading>
            </Box>
          </Flex>
        )
      case "loading":
        return <></>
      default:
        return (
          <Box mt="-1px">
            <Box
              borderRadius={"5px"}
              p="18px 10px"
              mt={logoMarginTop}
              background={conditionalLogoBG}
              ml="10px"
            >
              <Heading
                as="h1"
                fontFamily="roboto"
                fontWeight={600}
                fontSize="30px"
                letterSpacing="2px"
                lineHeight="20px"
                color="black"
              >
                {platformName}
              </Heading>
            </Box>
          </Box>
        )
    }
  }

  const isApp = useIsMobileApp()
  const meetingClient = useContext(SDKContext)

  let appHomePage = undefined
  switch (platformName) {
    case "LearnMachine":
      appHomePage = "https://learnmachine.ai"
      break
    case "LiveSell":
      appHomePage = "https://livesell.co"
      break
    case "Utta":
      appHomePage = "https://utta.app"
      break
    case "x121":
      appHomePage = "https://x121.ai"
      break
  }

  return (
    <Link
      display="flex"
      flexDir="row"
      alignItems="center"
      pos="relative"
      // top={isMobileLandscape ? "6px" : ["12px", null, "26px"]}
      left={showLogo ? "unset" : "4px"}
      href={isApp && appHomePage ? undefined : appHomePage}
      onClick={
        isApp
          ? () =>
              meetingClient?.nativeBridge.eventUserNavigatedBackIntoNativeScreen()
          : undefined
      }
      _focus={{}}
      _active={{}}
      _hover={{}}
    >
      {renderLogoOrText()}
    </Link>
  )
}
